import { typeRootState } from 'src/store';
import { useSelector } from 'react-redux';

export const useGetCurrentUser = () => {
    const user = useSelector((state: typeRootState) => state.user);
    return user;
}
